/** Long enough to swallow a typed word, short enough that the grid never feels stuck. */
export const SEARCH_DEBOUNCE_MS = 350;

/**
 * Mirrors the `minLength` on `GET /v1/catalog/items`'s `search` parameter, which is
 * `MIN_SEARCH_LENGTH` in `apps/api/app/modules/catalog/search.py`. Below the trigram width the
 * query cannot be served by either full-text index, so the API answers 422 — and a 422 under the
 * search box is a punishment for typing, not an answer. A shorter input is therefore treated as
 * "no search yet" and never sent.
 *
 * It is a plain constant because OpenAPI string constraints do not survive into `schema.d.ts`;
 * the generator emits `search?: string | null` and drops the bound. `searchRules.test.ts` pins
 * the value against the committed contract so a change on the backend fails here rather than in
 * production.
 */
export const MIN_SEARCH_LENGTH = 3;

/** The term to send for what was typed: the trimmed input, or nothing while it is too short. */
export function toSearchTerm(input: string): string {
  const trimmed = input.trim();
  return trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : '';
}
